export const apiConstants = {
  changePreferredHomeClub: 'Prospect/ChangePreferredHomeClub',
  changeHomeClub: 'Member/ChangeHomeClub',
  discover: 'Prospect/Discover',
};
